import React, { forwardRef } from "react";
import { Box, Stack, Typography, Grid } from "@mui/material";
import { DotedBox, PicBox, RowItem } from "./styles";
import PhoneIcon from "@mui/icons-material/Phone";
import LanguageIcon from "@mui/icons-material/Language";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import FacebookIcon from "@mui/icons-material/Facebook";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InstagramIcon from "@mui/icons-material/Instagram";
import moment from "moment";

export const UserDetailsPrint = forwardRef(({ detail }, ref) => {
  console.log("ref:", ref);
  console.log("detail:", detail);

  const weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const date = new Date();
  let today = weekday[date.getDay()];

  const companyCode = localStorage.getItem("companyCode");
  const companyName = localStorage.getItem("company");
  let logo = localStorage.getItem("base_url");

  const getPageMargins = () => {
    return `@page { margin:  5px 20px !important }`;
  };

  return (
    <Box ref={ref}>
      <style>{getPageMargins()}</style>

      <Stack width="100%" direction="row" justifyContent="space-between">
        <Typography variant="h6">Sale Receipt</Typography>

        <Box align="center">
          <img width="100px" src={logo} alt="" />
          <Typography variant="h6" sx={{ fontStyle: "bold" }}>
            {companyName}
          </Typography>
        </Box>

        <Stack>
          {detail?.srNum && (
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography sx={{ mr: 1, mt: 2, mb: 1 }}>Sr#</Typography>
              <DotedBox sx={{ textAlign: "center", minWidth: "80px" }}>
                <Typography>{detail?.srNum || 1}</Typography>
              </DotedBox>
            </Stack>
          )}
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography>Date</Typography>
            <DotedBox>
              <Typography>{detail?.date}</Typography>
            </DotedBox>
          </Stack>
        </Stack>
      </Stack>

      <Grid container spacing={1} marginTop="20px">
        <Grid item xs={3.3}>
          <Typography>Received with Thanks From</Typography>
        </Grid>
        <Grid item xs={2.9}>
          <DotedBox sx={{ width: "100%" }}>
            <Typography>{detail.cName}</Typography>
          </DotedBox>
        </Grid>
        <Grid item xs={1.3}>
          <Typography>s/o</Typography>
        </Grid>
        <Grid item xs={4.5}>
          <DotedBox sx={{ width: "100%" }}>
            <Typography>{detail?.cFatherName}</Typography>
          </DotedBox>
        </Grid>

        <Grid item xs={3}>
          <Typography>Sum of Rs</Typography>
        </Grid>
        <Grid item xs={3.2}>
          <DotedBox sx={{ width: "100%" }}>
            <Typography>{detail.vAmountNumbers}</Typography>
          </DotedBox>
        </Grid>
        <Grid item xs={1.3}>
          <Typography>In Words</Typography>
        </Grid>
        <Grid item xs={4.5}>
          <DotedBox sx={{ width: "100%" }}>
            <Typography>{detail.vAmountWords}</Typography>
          </DotedBox>
        </Grid>
        <Grid item xs={3}>
          <Typography>Vehicle Reg No.</Typography>
        </Grid>
        <Grid item xs={3.2}>
          <DotedBox sx={{ width: "100%" }}>
            <Typography>
              {detail.vRegitration || detail.vRegistration}
            </Typography>
          </DotedBox>
        </Grid>
        <Grid item xs={1.3}>
          <Typography>Maker</Typography>
        </Grid>
        <Grid item xs={4.5}>
          <DotedBox sx={{ width: "100%" }}>
            <Typography>{detail.vMaker}</Typography>
          </DotedBox>
        </Grid>
        <Grid item xs={3}>
          <Typography>Color</Typography>
        </Grid>
        <Grid item xs={3.2}>
          <DotedBox sx={{ width: "100%" }}>
            <Typography>{detail.vColor}</Typography>
          </DotedBox>
        </Grid>
        <Grid item xs={1.3}>
          <Typography>Model</Typography>
        </Grid>
        <Grid item xs={4.5}>
          <DotedBox sx={{ width: "100%" }}>
            <Typography>{detail.vModel}</Typography>
          </DotedBox>
        </Grid>
        <Grid item xs={3}>
          <Typography>Engine</Typography>
        </Grid>
        <Grid item xs={3.2}>
          <DotedBox sx={{ width: "100%" }}>
            <Typography>{detail.vEngine}</Typography>
          </DotedBox>
        </Grid>
        <Grid item xs={1.3}>
          <Typography>Chesis</Typography>
        </Grid>
        <Grid item xs={4.5}>
          <DotedBox sx={{ width: "100%" }}>
            <Typography>{detail?.vChesis}</Typography>
          </DotedBox>
        </Grid>
      </Grid>
      <Typography sx={{ mt: 1.5, mb: 1.5 }}>
        And handed over the possession in running good conditions
      </Typography>
      <Grid container spacing={2} justifyContent="space-between">
        <Grid item xs={5}>
          <Box
            sx={{ height: "120px", width: "100%", border: "1px solid grey" }}
          ></Box>
        </Grid>
        <Grid item xs={7}>
          <Typography variant="subtitle1">
            The vehicle is my personal property and without any encumbrance and
            the above amount is full and final settlement of the sale
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: "bold" }}>Note:</Typography>
          <Typography variant="subtitle1">
            Dealer just act as a witness. Seller
          </Typography>

          <Typography variant="subtitle1">
            is responsible for the documents in any
          </Typography>
          <Typography variant="subtitle1">
            conditions. We are not responsible for
          </Typography>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            transfer after 10 days
          </Typography>

          <Stack direction="row" margin="20px 0">
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Day :
            </Typography>
            <DotedBox sx={{ mr: "15px" }}>
              <Typography variant="subtitle1">{today}</Typography>
            </DotedBox>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Time :
            </Typography>
            <DotedBox>
              <Typography variant="subtitle1">
                {moment().format("hh:mm A")}
              </Typography>
            </DotedBox>
          </Stack>

          <Typography variant="subtitle1" sx={{ mt: 1 }}>
            I will be responsible for its Damage, Loss, Taxes etc. After this
            date the vehicle is in perfect running condition. I am fully
            satisfied with the bargain. I have also been handed over all the
            necessary documents of the vehicle
          </Typography>

          <Grid marginTop="20px" container spacing={1}>
            <Grid item xs={12}>
              <Typography>Pyament Details:</Typography>
              <DotedBox sx={{ height: "80px", width: "100%" }}>
                <Typography>{detail.paymentDetails}</Typography>
              </DotedBox>
            </Grid>
            <Grid item xs={5}>
              <Typography>Dealer Commission</Typography>
            </Grid>
            <Grid item xs={7}>
              <DotedBox sx={{ width: "100%" }}>
                <Typography>{detail.commission}</Typography>
              </DotedBox>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6} sx={{ mt: -6 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <PicBox>
                {detail.sProfile ? (
                  <img
                    height="100px"
                    width="100px"
                    src={detail.sProfile}
                    alt=""
                  />
                ) : (
                  "Seller Picture"
                )}
              </PicBox>
            </Grid>
            <Grid item xs={3.5} sx={{ mt: -3 }}>
              <Typography>Signature :</Typography>
            </Grid>
            <Grid item xs={8.5} sx={{ mt: -2 }}>
              <hr
                style={{
                  color: "black",
                  backgroundColor: "black",
                  height: "2px",
                  width: "100%",
                }}
              />
            </Grid>
            <Grid item xs={3.5}>
              <Typography>Seller Name</Typography>
            </Grid>
            <Grid item xs={8.5}>
              <DotedBox sx={{ width: "100%" }}>
                <Typography>{detail.sName}</Typography>
              </DotedBox>
            </Grid>
            <Grid item xs={3.5}>
              <Typography>Father Name</Typography>
            </Grid>
            <Grid item xs={8.5}>
              <DotedBox sx={{ width: "100%" }}>
                <Typography>{detail.sFatherName}</Typography>
              </DotedBox>
            </Grid>
            <Grid item xs={3.5}>
              <Typography>Contact</Typography>
            </Grid>
            <Grid item xs={8.5}>
              <DotedBox sx={{ width: "100%" }}>
                <Typography>{detail.sContact}</Typography>
              </DotedBox>
            </Grid>
            <Grid item xs={3.5}>
              <Typography>CNIC#</Typography>
            </Grid>
            <Grid item xs={8.5}>
              <DotedBox sx={{ width: "100%" }}>
                <Typography>{detail.sCNIC}</Typography>
              </DotedBox>
            </Grid>
            <Grid item xs={3.5}>
              <Typography>Adress</Typography>
            </Grid>
            <Grid item xs={8.5}>
              <DotedBox sx={{ height: "45px", width: "100%" }}>
                <Typography>{detail.sAddress}</Typography>
              </DotedBox>
            </Grid>
          </Grid>

          <Grid marginTop="5px" container spacing={1}>
            <Grid item xs={12}>
              <PicBox>
                {detail.cProfile ? (
                  <img
                    height="100px"
                    width="100px"
                    src={detail.cProfile}
                    alt=""
                  />
                ) : (
                  "Customer Picture"
                )}
              </PicBox>
            </Grid>
            <Grid item xs={3.5} sx={{ mt: -3 }}>
              <Typography>Signature :</Typography>
            </Grid>
            <Grid item xs={8.5} sx={{ mt: -2 }}>
              <hr
                style={{
                  color: "black",
                  backgroundColor: "black",
                  height: "2px",
                  width: "100%",
                }}
              />
            </Grid>
            <Grid item xs={4.5}>
              <Typography>Customer Name</Typography>
            </Grid>
            <Grid item xs={7.5}>
              <DotedBox sx={{ width: "100%" }}>
                <Typography>{detail.cName}</Typography>
              </DotedBox>
            </Grid>
            <Grid item xs={3.5}>
              <Typography>Father Name</Typography>
            </Grid>
            <Grid item xs={8.5}>
              <DotedBox sx={{ width: "100%" }}>
                <Typography>{detail.cFatherName}</Typography>
              </DotedBox>
            </Grid>
            <Grid item xs={3.5}>
              <Typography>Contact</Typography>
            </Grid>
            <Grid item xs={8.5}>
              <DotedBox sx={{ width: "100%" }}>
                <Typography>{detail.cContact}</Typography>
              </DotedBox>
            </Grid>
            <Grid item xs={3.5}>
              <Typography>CNIC#</Typography>
            </Grid>
            <Grid item xs={8.5}>
              <DotedBox sx={{ width: "100%" }}>
                <Typography>{detail.cCNIC}</Typography>
              </DotedBox>
            </Grid>
            <Grid item xs={3.5}>
              <Typography>Adress</Typography>
            </Grid>
            <Grid item xs={8.5}>
              <DotedBox sx={{ height: "45px", width: "100%" }}>
                <Typography>{detail.cAddress}</Typography>
              </DotedBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={1} sx={{ mt: 1 }}>
        <Grid item xs={2.5}>
          <Stack direction="row" spacing={1}>
            <Typography>
              <PhoneIcon sx={{ color: "black" }} />
            </Typography>
            <Typography>+254712069570</Typography>
          </Stack>
        </Grid>
        <Grid item xs={2.5}>
          <Stack direction="row" spacing={1}>
            <Typography>
              <PhoneIcon sx={{ color: "black" }} />
            </Typography>
            <Typography>+254787374123</Typography>
          </Stack>
        </Grid>
        <Grid item xs={3.5}>
          <Stack direction="row" spacing={1}>
            <Typography>
              <FacebookIcon sx={{ color: "black" }} />
            </Typography>
            <Typography>Shahab Auto Empire Ltd</Typography>
          </Stack>
        </Grid>
        <Grid item xs={3.5}>
          <Stack direction="row" spacing={1}>
            <Typography>
              <InstagramIcon sx={{ color: "black" }} />
            </Typography>
            <Typography>Shahab Auto Empire Ltd</Typography>
          </Stack>
        </Grid>

        <Grid item xs={4}>
          <Stack direction="row" spacing={0.5}>
            <Typography>
              <MailOutlineIcon sx={{ color: "black" }} />
            </Typography>
            <Typography>shahabautoempire@gmail.com</Typography>
          </Stack>
        </Grid>

        <Grid item xs={8}>
          <Stack direction="row" spacing={0.5}>
            <Typography>
              <LocationOnIcon sx={{ color: "black" }} />
            </Typography>
            <Typography>
              Old Nation Building Moi Avenue, Kisumu Road, Mombasa, Kenya
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
});
